import { render, staticRenderFns } from "./SubscriberCreateEdit.vue?vue&type=template&id=36f59a68&"
import script from "./SubscriberCreateEdit.vue?vue&type=script&lang=js&"
export * from "./SubscriberCreateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports